import { slugs } from 'common/constants/inputTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import AudioNew from 'publisher/components/entities/AudioNew'
import Breadcrumbs from 'publisher/components/entities/Breadcrumbs'
import Column from 'publisher/components/entities/Column'
import ContentBox from 'publisher/components/entities/ContentBox'
import Countdown from 'publisher/components/entities/Countdown'
import Headline from 'publisher/components/entities/Headline'
import Image from 'publisher/components/entities/Image'
import NewBulletList from 'publisher/components/entities/NewBulletList'
import NewHorizontalLine from 'publisher/components/entities/NewHorizontalLine'
import NewLanguageSwitcher from 'publisher/components/entities/NewLanguageSwitcher'
import NewRawHtml from 'publisher/components/entities/NewRawHtml'
import OptInRecaptcha from 'publisher/components/entities/OptInRecaptcha'
import { PopupNew } from 'publisher/components/entities/popup-new'
import Row from 'publisher/components/entities/Row'
import Section from 'publisher/components/entities/Section'
import SurveyNew from 'publisher/components/entities/Survey/SurveyNew'
import TextNew from 'publisher/components/entities/TextNew'
import TwitterTweetButton from 'publisher/components/entities/TwitterTweetButton'
import VideoNew from 'publisher/components/entities/Video'
import PriceElement from 'publisher/pages/sale-page/components/price-element'
import React from 'react'
import OptInButtonNew from 'src/publisher/entities/button-new'
import { Carousel } from 'src/publisher/entities/carousel'
import Checkbox from 'src/publisher/entities/checkbox/checkbox'
import { Faq } from 'src/publisher/entities/faq'
import BaseFieldNew from 'src/publisher/entities/field-new/base-field'
import CountryFieldNew from 'src/publisher/entities/field-new/country-field'
import EmailFieldNew from 'src/publisher/entities/field-new/email-field'
import PhoneNumberFieldNew from 'src/publisher/entities/field-new/phone-number-field'
import { LoginButton } from 'src/publisher/entities/login-button'
import { Menu } from 'src/publisher/entities/menu'
import { RegistrationButton } from 'src/publisher/entities/registration-button'
import { WebsiteButton } from 'src/publisher/entities/website-button'
import { WebsiteFooter } from 'src/publisher/entities/website-footer'
import { WebsiteHeader } from 'src/publisher/entities/website-header'
import { WebsiteLanguageSwitcher } from 'src/publisher/entities/website-language-switcher'
import { WebsiteLayoutBody } from 'src/publisher/entities/website-layout-body'
import { WebsiteLogo } from 'src/publisher/entities/website-logo'
import { WebsitePageBody } from 'src/publisher/entities/website-page-body'

export const createEntityElement = () => {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  return (entity: any, additionalProps = {}) => {
    const key = `entity-${entity.id}`
    switch (entity.type) {
      case EntityTypeEnum.Row:
        return <Row entity={entity} key={key} />
      case EntityTypeEnum.Section:
        return <Section entity={entity} key={key} />
      case EntityTypeEnum.Column:
        return <Column entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.BulletList:
        return <NewBulletList entity={entity} key={key} />
      case EntityTypeEnum.Button:
        return <OptInButtonNew entity={entity} key={key} />
      case EntityTypeEnum.Field:
        switch (entity.slug) {
          case slugs.EMAIL:
            return <EmailFieldNew entity={entity} />
          case slugs.COUNTRY:
            return <CountryFieldNew entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberFieldNew entity={entity} />
          case slugs.PASSWORD:
          case slugs.CONFIRM_PASSWORD:
            return <BaseFieldNew entity={entity} type="password" />
          default:
            return <BaseFieldNew entity={entity} key={key} />
        }
      case EntityTypeEnum.ContentBox:
        return <ContentBox entity={entity} key={key} />
      case EntityTypeEnum.RawHtml:
        return <NewRawHtml entity={entity} key={key} />
      case EntityTypeEnum.Checkbox:
        return <Checkbox entity={entity} key={key} />
      case EntityTypeEnum.Countdown:
        return <Countdown entity={entity} key={key} />
      case EntityTypeEnum.Menu:
        return <Menu entity={entity} key={key} />
      case EntityTypeEnum.LanguageSwitcher:
        return <NewLanguageSwitcher entity={entity} key={key} />
      case EntityTypeEnum.PriceElement:
        return <PriceElement entity={entity} key={key} />
      case EntityTypeEnum.HorizontalLine:
        return <NewHorizontalLine entity={entity} key={key} />
      case EntityTypeEnum.Carousel:
        return <Carousel entity={entity} key={key} />
      case EntityTypeEnum.Text:
        return <TextNew entity={entity} key={key} />
      case EntityTypeEnum.Headline:
        return <Headline entity={entity} key={key} />
      case EntityTypeEnum.Recaptcha:
      case EntityTypeEnum.OptInRecaptcha:
        return <OptInRecaptcha entity={entity} key={key} />
      case EntityTypeEnum.Breadcrumbs:
        return <Breadcrumbs entity={entity} key={key} />
      case EntityTypeEnum.Video:
        return <VideoNew entity={entity} key={key} />
      case EntityTypeEnum.Image:
        return <Image entity={entity} key={key} />
      case EntityTypeEnum.Audio:
        return <AudioNew entity={entity} key={key} />
      case EntityTypeEnum.TwitterTweetButton:
        return <TwitterTweetButton entity={entity} key={key} />
      case EntityTypeEnum.Survey:
        return <SurveyNew entity={entity} key={key} />
      case EntityTypeEnum.Faq:
        return <Faq entity={entity} key={key} />
      case EntityTypeEnum.Popup:
        return <PopupNew entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.WebsiteHeader:
        return <WebsiteHeader entity={entity} key={key} />
      case EntityTypeEnum.WebsiteFooter:
        return <WebsiteFooter entity={entity} key={key} />
      case EntityTypeEnum.WebsiteLayoutBody:
        return <WebsiteLayoutBody entity={entity} key={key} />
      case EntityTypeEnum.WebsitePageBody:
        return <WebsitePageBody entity={entity} key={key} />
      case EntityTypeEnum.WebsiteLogo:
        return <WebsiteLogo entity={entity} key={key} />
      case EntityTypeEnum.WebsiteLanguageSwitcher:
        return <WebsiteLanguageSwitcher entity={entity} key={key} />
      case EntityTypeEnum.WebsiteButton:
        return <WebsiteButton entity={entity} key={key} />
      case EntityTypeEnum.LoginButton:
        return <LoginButton entity={entity} key={key} />
      case EntityTypeEnum.RegistrationButton:
        return <RegistrationButton entity={entity} key={key} />
      default:
        return <div /> /* let's return empty div temporarily */
      // throw new Error(`unknown type ${entity.type} of node id = ${entity.id}`)
    }
  }
}
